var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_87790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.88294 0 0.5 5.38294 0.5 12C0.5 18.6171 5.88294 24 12.5 24C19.1171 24 24.5 18.6171 24.5 12C24.5 5.38294 19.1171 0 12.5 0ZM17.75 12.9999H13.4999V17.25C13.4999 17.802 13.052 18.2499 12.5 18.2499C11.948 18.2499 11.5001 17.802 11.5001 17.25V12.9999H7.25C6.69795 12.9999 6.25006 12.552 6.25006 12C6.25006 11.448 6.69795 11.0001 7.25 11.0001H11.5001V6.75C11.5001 6.19795 11.948 5.75006 12.5 5.75006C13.052 5.75006 13.4999 6.19795 13.4999 6.75V11.0001H17.75C18.302 11.0001 18.7499 11.448 18.7499 12C18.7499 12.552 18.302 12.9999 17.75 12.9999Z",
    fill: "#6F2ECA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_87790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateIcon);
export default __webpack_public_path__ + "static/media/create_icon.925528aec7c93ad913321a7b0e6da2cd.svg";
export { ForwardRef as ReactComponent };